var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerGameTypeProMono(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.444 4.54C8.951 2.973 8 2 8 2s-.953.972-2.443 2.54C4.77 5.37 3 7.423 3 9.465c0 1.362 1.049 2.465 2.343 2.465.849 0 1.59-.476 2-1.188a.24.24 0 01.185-.095c.12 0 .23.089.218.2-.09.734-.483 2.543-2.032 3.154h4.572c-1.548-.61-1.941-2.42-2.031-3.154-.013-.111.097-.2.217-.2.074 0 .143.043.185.096v-.001c.41.712 1.151 1.188 2 1.188C11.95 11.93 13 10.826 13 9.464c0-2.042-1.77-4.095-2.556-4.923z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.027 7.874l.636 2.057-1.662-1.272-1.663 1.272.635-2.057-1.664-1.272h2.057l.635-2.057.634 2.057h2.056L9.027 7.874z",
    fill: "#fff"
  })));
}
SvgPokerGameTypeProMono.displayName = 'PokerGameTypeProMono';
export default SvgPokerGameTypeProMono;